import { Component, OnInit, computed, inject, signal } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';
import { IconService } from './services/icon.service';
import { FooterComponent } from './shared/footer/footer.component';
import { BrandingService } from './services/branding.service';
import { AuthService } from './services/auth.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { LayoutShellComponent } from './layout/layout-shell.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, FooterComponent, LayoutShellComponent, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'rad';
  private router = inject(Router);
  currentUrl = signal<string>('');

  // Routes that should NOT use the dashboard layout
  private noLayoutRoutes = [
    '/home',
    '/login',
    '/signup',
    '/verify-otp',
    '/reset-password',
    '/set-password',
    '/unauthorized'
  ];

  useDashboardLayout = computed(() => {
    const url = this.currentUrl();
    return !this.noLayoutRoutes.some(r => url.startsWith(r));
  });

  constructor(
    private iconService: IconService,
    private brandingService: BrandingService,
    private authService: AuthService,
    private googleAnalytics: GoogleAnalyticsService,
  ) {
    // This will ensure Material Icons are loaded
  }

  ngOnInit(): void {
    // Initialize branding when app starts
    this.initializeBranding();
    this.googleAnalytics.init();
    // Track current route to switch layouts without changing routes/guards
    this.currentUrl.set(this.router.url);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.currentUrl.set(this.router.url);
      window.scrollTo(0, 0);
    });
  }

  private initializeBranding(): void {
    // Check if user is logged in and has ownerid
    if (this.authService.isLoggedIn()) {
      const userInfo = this.authService.getCurrentUserInfo();

      // Check if user has ownerid (this would need to be added to the user data structure)
      // For now, we'll check if there's owner branding data in localStorage
      const ownerBranding = localStorage.getItem('ownerBranding');

      if (ownerBranding) {
        try {
          const owner = JSON.parse(ownerBranding);
          this.brandingService.applyOwnerBranding(owner);
        } catch (error) {
          console.error('Error parsing owner branding data:', error);
        }
      }
    } else {
      // Reset to default branding if not logged in
      this.brandingService.resetToDefaultBranding();
    }
  }
}
